import AudiencePage from '@/components/marketing/technology/AudiencePage'
import BrandedPortalMockup from '@/components/marketing/technology/BrandedPortalMockup'
import type { TechnologyAudienceProps } from '@/types/technology'

/* /technology/white-label — the distributors' audience page.
 *
 * The one page in the section that writes "white label" out: it is the phrase
 * this buyer searches. Everywhere else (the labels page above all) the
 * capability is described rather than labelled, and a test enforces both
 * directions. Its one visual is the brand-switching portal mockup.
 */
export default function WhiteLabel(props: TechnologyAudienceProps) {
  return <AudiencePage {...props} media={<BrandedPortalMockup />} />
}
